export * from './queries';

export const basketKeys = {
  basket: (accountId: string, basketId?: string) => ['basket', accountId, basketId ?? ''],
};
